import mainViewMixin from '../mainViewMixin';
import { mapState } from 'vuex';
import { themesMixin, vuetifyColors } from '@/utils/themes';
import get from 'lodash/get';
import set from 'lodash/set';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWManagement',
  mixins: [mainViewMixin, themesMixin],
  data: function () {
    return {
      accountId: undefined,
      filteredList: [],
      filterAlert: false,
      filterWarning: false,
      gatewayCsvImportDialog: false,
      originatorDialog: false,
      visualizationDialog: false,
      hasNonEmptyList: false,
      timeIntDialog: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    headerBG() {
      return './img/gwmgmt.png';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    getColor(type) {
      return vuetifyColors[type] || this.vuetifyColorHex('info');
    },
    updateList() {
      this.$refs.list.fetchList();
    },
    addDevice() {
      this.editedItem = {};
      this.originatorDialog = true;
    },
    async selectedOriginator(originator) {
      if (!get(this.editedItem, 'properties')) {
        set(this.editedItem, 'properties', {});
      }
      this.editedItem.properties.originator = {
        id: originator.id
      };
      this.editedItem.properties.datasource = {
        id: get(originator, 'datasource.id')
      };
      this.originatorDialog = false;
      this.formDialog = true;
    },
    loadedInitialConfig(e) {
      this.accountId = e.accountId;
      this.filterWarning = e.filterWarning;
      this.filterAlert = e.filterAlert;
      this.$nextTick(() => {
        this.$refs['list'].fetchList();
      });
    },
    resetFilter() {
      this.accountId = undefined;
      this.filterWarning = false;
      this.filterAlert = false;
      this.updateList();
    },
    editDevice(item) {
      this.editedItem = item;
      this.formDialog = true;
    },
    pushMapToRouter() {
      let accountId = this.accountId || this.$store.state.authentication.tenantId;
      this.$router.push(`/niota-classic/gw-mgmt/map/${accountId}/gateways/?warning=${this.filterWarning}&alert=${this.filterAlert}`);
    },
    closeVisualization() {
      this.visualizationDialog = false;
    },
    closeTimeIntervalModal() {
      this.timeIntDialog = false;
    }
  }
};